import React from 'react';
import { Route } from 'react-router';

import { ROUTES } from '../../../../core/router/routes';
import ArticleShow from '../../ArticleShow';
import ArticleResults from '../../ArticleResults';

const ArticleRoute = () => [
  <Route path={ROUTES.ARTICLE.SHOW} key={ROUTES.ARTICLE.SHOW} component={ArticleShow} />,
  <Route path={ROUTES.ARTICLE.RESULTS} key={ROUTES.ARTICLE.RESULTS} component={ArticleResults} />,
];

export default ArticleRoute;
